'use client';
import { useState as c } from "react";
import { useIsomorphicLayoutEffect as d } from "./use-isomorphic-layout-effect.js";
const m = typeof window > "u";
function u(n, {
  defaultValue: r = !0,
  initializeWithValue: o = !0
} = {}) {
  const i = (e) => m ? r : window.matchMedia(e).matches, [s, a] = c(() => o ? i(n) : r);
  function t() {
    a(i(n));
  }
  return d(() => {
    const e = window.matchMedia(n);
    return t(), e.addListener ? e.addListener(t) : e.addEventListener("change", t), () => {
      e.removeListener ? e.removeListener(t) : e.removeEventListener("change", t);
    };
  }, [n]), s;
}
export {
  u as useMediaQuery
};
